import React, { useEffect, useState } from "react";
import Pagination from "../components/Elements/Pagination";
import { fetchEntityData } from "../utils/RequestHandler";
import LoadingSpinner from "../components/Elements/LoadingSpinner";
import TalentCard from "../components/Elements/TalentCard";
import EmptyState from "../components/Elements/EmptyState";
import {
  Body,
  Container,
  PaginationWrapper,
  Wrapper,
  ViewList,
  HeaderInfo,
} from "../style/view.styles";
import FilterSidebar from "../components/Elements/FilterSidebar";
import { useNavigate } from "react-router-dom";

const filters = [
  {
    filter: "Interests",
    options: ["Software Engineering", "Accounting"],
  },
];

export default function FindTalent() {
  const [talentList, setTalentList] = useState([]);
  const [filteredTalents, setFilteredTalents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTalent, setSelectedTalent] = useState(null);
  const navigate = useNavigate();

  const recordsPerPage = 9;

  useEffect(() => {
    const fetchTalents = async () => {
      try {
        const data = await fetchEntityData("talents");
        if (data.success) {
          setTalentList(data.result);
          setFilteredTalents(data.result);
        }
      } catch (error) {
        console.error("Failed to load talents", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTalents();
  }, []);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = talentList.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const handlePageChange = (page) => setCurrentPage(page);

  const handleClickTalent = (talent) => {
    setSelectedTalent(talent);
    navigate("/find-talent-connect", {
      state: { talent },
    });
  };

  return (
    <Wrapper className="paleBlueGreyBg">
      <Container>
        {/* Sidebar Section */}
        <FilterSidebar filters={filters} />
        {/* Body Section */}
        <Body>
          <HeaderInfo>
            <h1 className="font30 darkGreenColor extraBold">
              Available Talents
            </h1>
          </HeaderInfo>
          {loading && <LoadingSpinner />}
          {!loading && filteredTalents?.length === 0 && (
            <EmptyState message={"Talents soon to be available"} />
          )}
          {!loading && filteredTalents?.length > 0 && (
            <ViewList>
              {currentRecords.map((talent) => (
                <TalentCard
                  name={`${talent.first_name} ${talent.last_name}`}
                  expertise={talent.education_level}
                  description={talent.skills}
                  location={talent.location}
                  action={() => handleClickTalent(talent)}
                  isSelected={selectedTalent === talent}
                />
              ))}
            </ViewList>
          )}
          {filteredTalents.length > recordsPerPage && (
            <PaginationWrapper>
              <Pagination
                totalItems={talentList.length}
                itemsPerPage={recordsPerPage}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            </PaginationWrapper>
          )}
        </Body>
      </Container>
    </Wrapper>
  );
}
